import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Hero from './components/Hero';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import AttractionsInMalthan from './pages/AttractionsInMalthan';
import Activities from './pages/Activities';
import PackagesSection from './pages/packagesData';
import NearbyPlaces from './pages/NearbyPlaces';
import Gallery from './pages/Gallery';
import ContactSection from './pages/ContactInfo';
import EnquiryForm from './pages/EnquiryForm';
import Privacy from './pages/Privacy';
import Termcondition from './pages/Termcondition';
import Packages from './pages/PackageCard';
import ScrollToTop from './components/ScrollToTop';
import Onedaypicnicspot from './pages/One Day Picnic Spot Near Pune at Morachi Chincholi';
import Punenearbyattraction from './pages/Pune nearby attractions';
import Morachichincholi from './pages/Morachi Chincholi';
import Morachichincholipunenear from './pages/Morachi Chincholi Pune Nearby Attractions';
import Daytrip from './pages/Day Trip Destinations Near Morachi Chincholi Pune';
import Placestovisit from './pages/Places to Visit Nearby Morachi Chincholi Pune';
import Onewaygatwaymorachi from './pages/One-day Getaway Morachi Chincholi Pune';
import Morachichincholitourist from './pages/Morachi Chincholi Tourist Spot Near Pune';
import Dayoutiingplace from './pages/Day Outing Place Anand Krushi Paryatan Kendra Morachi Chincholi Pune';
import Anandkrushiparyatankendra from './pages/Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism';
import Agrotourismmorachichincholi from './pages/Agro Tourism Morachi Chincholi';
import Morachincholitouristattraction from './pages/Morachi Chincholi Tourist attractions nearby Pune';
import Daytourdextinationnearmorachi from './pages/Day tour destinations near Morachi Chincholi Pune';
import Morachichincholipuneplacetoexplorenearby from './pages/Morachi Chincholi Pune Place to explore nearby';
import Punenearbysightseeingspot from './pages/Pune Nearby sightseeing spot Morachi Chincholi';
import Daytripideasnearpunemorachi from './pages/Day trip ideas near Pune Morachi Chincholi with Family';
import Quickdaytripdestinationmorachi from './pages/Quick day trip destinations Morachi Chincholi Pune';
import Morachichincholibestplace from './pages/Morachi Chincholi Best Place Near Pune for Short Visit';
import Shorttripdestinationmorachi from './pages/Short Trip Destinations Morachi Chincholi Pune';
import Hurdapartymorachichincholi from './pages/Hurda Party Morachi Chincholi';
import Mangomahotsavmorachichincholi from './pages/Mango Mahostav Morachi Chincholi';
import Morachichincholiwaterpark from './pages/Morachi Chincholi water park';
import Morachichincholiactivities from './pages/Morachi Chincholi Activities';
import Morachichincholihomestay from './pages/Morachi Chincholi Home Stay';
import Corporateoutingmorachichincholi from './pages/Corporate Outing Morachi Chincholi Pune';
import Destinationweddingmorachichincholi from './pages/Destination Wedding Morachi Chincholi Pune';
import Birthdaypartyhoisting from './pages/Birthday Party Hosting Morachi Chincholi Near Pune';
import Onedayschoolpicnic from './pages/One-day School Picnic Near Morachi Chincholi Pune';
import Colloegepicnic from './pages/College Picnic Places at Morachi Chincholi Pune';
import Corporateeventshoisting from './pages/Corporate Event Hosting Morachi Chincholi Pune';
import Campngplacemorachichincholi from './pages/Camping Place Morachi Chincholi Pune';
import Morachichincholipackages from './pages/Morachi Chincholi Package';
import Resortnearpuneforevents from './pages/Resort Near Pune for Event Celebration Morachi Chincholi';
import Familygettogether from './pages/Family Get-Together Morachi Chincholi Near Pune';
import Morachichincholiresort from './pages/Morachi Chincholi Resort Pune';
import Morachichincholifarmhous from './pages/Morachi Chincholi Farmhouse Near Pune on Rent';
import Preweddingshootdestinationmorachi from './pages/Pre-Wedding Shoot Destination Morachi Chincholi Pune';
import Adventureactivities from './pages/Adventure Activities at Morachi Chincholi Pune';
import Morachichincholionlinebooking from './pages/Morachi Chincholi Online Booking';
import Schoolpicnicorganiser from './pages/School Picnic Organisers in Pune';
import Morachichincholischoolpicnic from './pages/Morachi Chincholi School Picnic';
import Schoolpicnicorganiserinpimprichichwad from './pages/School Picnic Organisers in Pimpri Chinchwad';
import Morachichincholischoolpicninc from './pages/Morachi Chincholi School Picnic Spot';
import Onedayschoolpicnicspotnearpune from './pages/One Day School Picnic Spot Near Pune';
import Onedayschoolspotpunewithinpune from './pages/One Day School Picnic Spot Near Pune Within 100 Kms';
import Onedayschoolpicnicspotnearpunewhith from './pages/One Day School Picnic Spot Near Pune Within 50 Kms';
import Ranjangaonganpat from './pages/Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi School Picnic';
import Schoolpicnicspotnear from './pages/School Picnic Spots Near Pune for Students Classes';
import Morachichincholiwaterparkonlinebooking from './pages/Morachi Chincholi Water Park Online Booking';
import Morachichincholitourpackages from './pages/Morachi Chincholi Tour Package';
import ContactButtons from './components/ContactButtons';
import Videos from './pages/videoes';





function App() {
  return (
    <Router>
      <Header/>
<ScrollToTop/>
<ContactButtons/>
      <Routes>

        <Route path="/" element={<Hero />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/attraction" element={<AttractionsInMalthan />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/package" element={<PackagesSection />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/near-places" element={<NearbyPlaces />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/enquiry" element={<EnquiryForm />} />
        <Route path="/Privacy-policy" element={<Privacy />} />
        <Route path="/Term-condition" element={<Termcondition />} />

        <Route path="/One-Day-Picnic-Spot-Near-Pune-at-Morachi-Chincholi" element={<Onedaypicnicspot />} />
       
<Route path="/Pune-Nearby-Attractions" element={<Punenearbyattraction />} />
<Route path="/Morachi-Chincholi" element={<Morachichincholi />} />
<Route path="/Morachi-Chincholi-Pune-Nearby-Attractions" element={<Morachichincholipunenear />} />
<Route path="/Day-Trip-Destinations-Near-Morachi-Chincholi-Pune" element={<Daytrip />} />
<Route path="/Places-to-Visit-Nearby-Morachi-Chincholi-Pune" element={<Placestovisit/>} />
<Route path="/One-Day-Getaway-Morachi-Chincholi-Pune" element={<Onewaygatwaymorachi />} />
<Route path="/Morachi-Chincholi-Tourist-Spot-Near-Pune" element={<Morachichincholitourist />} />
<Route path="/Day-Outing-Place-Anand-Krushi-Paryatan-Kendra-Morachi-Chincholi-Pune" element={<Dayoutiingplace />} />
<Route path="/Anand-Krushi-Paryatan-Kendra-Morachi-Chincholi-Pune-Agro-Tourism" element={<Anandkrushiparyatankendra />} />
<Route path="/Agro-Tourism-Morachi-Chincholi" element={<Agrotourismmorachichincholi />} />
<Route path="/Morachi-Chincholi-Tourist-Attractions-Nearby-Pune" element={<Morachincholitouristattraction />} />
<Route path="/Day-Tour-Destinations-Near-Morachi-Chincholi-Pune" element={<Daytourdextinationnearmorachi />} />
<Route path="/Morachi-Chincholi-Pune-Place-to-Explore-Nearby" element={<Morachichincholipuneplacetoexplorenearby />} />
<Route path="/Pune-Nearby-Sightseeing-Spot-Morachi-Chincholi" element={<Punenearbysightseeingspot />} />
<Route path="/Day-Trip-Ideas-Near-Pune-Morachi-Chincholi-With-Family" element={<Daytripideasnearpunemorachi />} />
<Route path="/Quick-Day-Trip-Destinations-Morachi-Chincholi-Pune" element={<Quickdaytripdestinationmorachi />} />

<Route path="/Morachi-Chincholi-Best-Place-Near-Pune-for-Short-Visit" element={<Morachichincholibestplace />} />
<Route path="/Short-Trip-Destinations-Morachi-Chincholi-Pune" element={<Shorttripdestinationmorachi />} />
<Route path="/Hurda-Party-Morachi-Chincholi" element={<Hurdapartymorachichincholi />} />
<Route path="/Mango-Mahotsav-Morachi-Chincholi" element={<Mangomahotsavmorachichincholi />} />
<Route path="/Morachi-Chincholi-Water-Park" element={<Morachichincholiwaterpark />} />
<Route path="/Morachi-Chincholi-Activities" element={<Morachichincholiactivities />} />
<Route path="/Morachi-Chincholi-Home-Stay" element={<Morachichincholihomestay />} />
<Route path="/Corporate-Outing-Morachi-Chincholi-Pune" element={<Corporateoutingmorachichincholi />} />
<Route path="/Destination-Wedding-Morachi-Chincholi-Pune" element={<Destinationweddingmorachichincholi />} />
<Route path="/Birthday-Party-Hosting-Morachi-Chincholi-Near-Pune" element={<Birthdaypartyhoisting />} />
<Route path="/One-Day-School-Picnic-Near-Morachi-Chincholi-Pune" element={<Onedayschoolpicnic />} />
<Route path="/College-Picnic-Places-at-Morachi-Chincholi-Pune" element={<Colloegepicnic />} />
<Route path="/Corporate-Event-Hosting-Morachi-Chincholi-Pune" element={<Corporateeventshoisting />} />
<Route path="/Camping-Place-Morachi-Chincholi-Pune" element={<Campngplacemorachichincholi />} />
<Route path="/Morachi-Chincholi-Package" element={<Morachichincholipackages />} />
<Route path="/Resort-Near-Pune-for-Event-Celebration-Morachi-Chincholi" element={<Resortnearpuneforevents />} />
<Route path="/Family-Get-Together-Morachi-Chincholi-Near-Pune" element={<Familygettogether />} />



<Route path="/Morachi-Chincholi-Resort-Pune" element={<Morachichincholiresort />} />
<Route path="/Morachi-Chincholi-Farmhouse-Near-Pune-On-Rent" element={<Morachichincholifarmhous />} />
<Route path="/Pre-Wedding-Shoot-Destination-Morachi-Chincholi-Pune" element={<Preweddingshootdestinationmorachi />} />
<Route path="/Adventure-Activities-at-Morachi-Chincholi-Pune" element={<Adventureactivities />} />
<Route path="/Morachi-Chincholi-Online-Booking" element={<Morachichincholionlinebooking />} />
<Route path="/School-Picnic-Organisers-in-Pune" element={<Schoolpicnicorganiser />} />
<Route path="/Morachi-Chincholi-School-Picnic" element={<Morachichincholischoolpicnic />} />
<Route path="/School-Picnic-Organisers-in-Pimpri-Chinchwad" element={<Schoolpicnicorganiserinpimprichichwad />} />
<Route path="/Morachi-Chincholi-School-Picnic-Spot" element={<Morachichincholischoolpicninc />} />
<Route path="/One-Day-School-Picnic-Spot-Near-Pune" element={<Onedayschoolpicnicspotnearpune />} />
<Route path="/One-Day-School-Picnic-Spot-Near-Pune-Within-100-Kms" element={<Onedayschoolspotpunewithinpune />} />
<Route path="/One-Day-School-Picnic-Spot-Near-Pune-Within-50-Kms" element={<Onedayschoolpicnicspotnearpunewhith />} />
<Route path="/Ranjangaon-Ganpati-Nighoj-Kund-Morachi-Chincholi-School-Picnic" element={<Ranjangaonganpat />} />
<Route path="/School-Picnic-Spots-Near-Pune-for-Students-Classes" element={<Schoolpicnicspotnear />} />
<Route path="/Morachi-Chincholi-Water-Park-Online-Booking" element={<Morachichincholiwaterparkonlinebooking />} />
<Route path="/Morachi-Chincholi-Tour-Package" element={<Morachichincholitourpackages />} />

      </Routes>
     <Footer/>
    </Router>


  );
}

export default App;
